import { Injectable, ComponentFactoryResolver, ViewContainerRef, Type } from '@angular/core';
import { WidgetMap } from './widget-map';

@Injectable({
  providedIn: 'root'
})
export class WidgetLoaderService {
  constructor(private resolver: ComponentFactoryResolver) { }

  loadComponent(viewContainerRef: ViewContainerRef, componentType: Type<any>, key: string) {
    const factory = this.resolver.resolveComponentFactory(componentType);
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent(factory);
    componentRef.instance.widgetKey = key;
  }

  getComponentType(key: string): Type<any> | undefined {
    return WidgetMap.get(key);
  }
}
